module.exports = __webpack_public_path__ + "img/logoSindhoteis.cc4c4c56.jpg";